<template>
  <div class="assignment-footer">
    <div class="assignment-footer-left">
      <div
        v-if="assignment.is_kindle"
        class="assignment-badge assignment-badge-kindle"
      >
        Kindle Unlimited
      </div>
      <div
        v-if="assignment.is_verified"
        class="assignment-badge assignment-badge-verified"
      >
        <div v-if="!assignment.listing_price">
          Verified Purchase Free Promo
        </div>
        <div v-else>
          Verified Purchase ${{ assignment.listing_price - 0.01 }}
        </div>
      </div>
      <div
        v-if="assignment.is_speedy"
        class="assignment-badge assignment-badge-speedy"
      >
        Speedy
      </div>
      <div
        v-if="assignment.is_star_protection"
        class="assignment-badge assignment-badge-protected"
      >
        5-Star Protection
      </div>
      <div
        v-if="assignment.is_recommended_readers"
        class="assignment-badge assignment-badge-recommended"
      >
        Recommended Reader
      </div>
      <div v-if="assignment.status === 'Open'">Edit {{ assignment.id }}</div>
    </div>
    <div class="assignment-footer-right">
      <div v-if="!wasApprovedCancelled" class="points-container">
        <div class="points">{{ assignment.points | bigNumber }}</div>
        <div class="points-icon">
          <img src="/images/icons/snap.svg" class="points-icon-img" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StatusMessages from "./StatusMessages";
import Points from "@/components/Points/Tag";

export default {
  name: "AssignmentFooter",
  components: { Points },
  props: ["assignment"],
  data: function () {
    return {};
  },
  created() {
    // console.log("lf", this.assignment);
  },
  computed: {
    wasApprovedCancelled() {
      if (this.assignment.status_messages) {
        return this.assignment.status_messages['approve-after-cancel'];
      }
      return false
    }
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.assignment-footer {
  border-top: 1px solid #eee;
  padding: 8px 0;
}
.assignment-footer-left {
  float: left;
  width: 75%;
}
.assignment-footer-right {
  float: right;
  width: 25%;
}

.assignment-badge {
  float: left;
  margin-right: 16px;
  padding-top: 5px;
  font-size: 11.5pt;
  //color: lighten($color-blue, 6%) !important;
  //color: #444 !important;
}
.assignment-badge-kindle {
  font-weight: 600;
  color: #e08d00;
}
.assignment-badge-verified {
  font-weight: 600;
  color: lighten(#ff7043, 8%);
}
.assignment-badge-speedy {
  font-weight: 500;
  color: lighten(#45a449, 4%);
}
.assignment-badge-protected {
  font-weight: 500;
  color: lighten($color-blue, 6%);
}
.assignment-badge-recommended {
  font-weight: 500;
  color: lighten(#b45ac3, 9%);
}

.points-container {
  border-radius: 28px;
  padding: 3px 0 0 0;
  zoom: 1;
}
.points-icon {
  float: right;
  padding-top: 7px;
}
.points-icon-img {
  float: right;
  width: 22px;
  color: $color-snaps;
  font-size: 18pt !important;
}
.points {
  float: right;
  color: darken($color-snaps, 0%);
  margin-left: 5px;
  font-size: 13pt !important;
  font-weight: 600;
  font-family: "Source Sans Pro";
}
</style>
